export default __webpack_public_path__ + "static/media/Kids_corner_learning_Tool.d3913336.jpg";